import { Container, Step, StepLabel, Stepper } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useStyles } from './horizontal-stepper.jss';

export default function HorizontalStepper({ config, actions }) {
  const { step, completedSteps, vehicleDetails, stepper } = useSelector(
    (state) => state.carBooking
  );
  const classes = useStyles();
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const history = useHistory();

  const stepperByBrand = process.env.REACT_APP_BRAND === 'dacia' ? config : stepper;

  const isStepCompleted = (step) => {
    return Object.keys(completedSteps).includes(step.toString());
  };

  const isCurrentStep = (step) => {
    return activeStep === step;
  };

  const isLastStep = () => {
    return activeStep === stepperByBrand.length - 1;
  };

  const pushToStep = (step) => {
    if (step === 0) {
      dispatch(actions.cleanUpSteps());
      history.push('/');
    }
    if (step === 1) history.push(`/kalendarz/${vehicleDetails?.vin}`);
    if (step === 2) history.push(`/formularz/${vehicleDetails?.vin}`);
    if (step === 3) history.push(`/podsumowanie/${vehicleDetails?.vin}`);
    if (step === 4) history.push(`/weryfikacja/${vehicleDetails?.vin}`);
  };

  const handleStep = (step) => {
    if (!isStepCompleted(step) || isCurrentStep(step) || isLastStep()) return;
    dispatch(actions.setStepNumber(step));
    pushToStep(step);
  };

  useEffect(() => {
    setActiveStep(step);
  }, [step]);

  useEffect(() => {
    if (!vehicleDetails) dispatch(actions.removeCompletedSteps());
  }, [actions, dispatch, vehicleDetails]);

  return (
    <>
      {step !== null ? (
        <Container disableGutters maxWidth="lg">
          <Stepper
            classes={{ root: classes.stepperRoot }}
            activeStep={step}
            alternativeLabel
            nonLinear
          >
            {stepperByBrand.map((label, index) => (
              <Step
                key={label}
                disabled={isLastStep() || !isStepCompleted(index)}
                classes={{
                  root: classes.stepRoot
                }}
              >
                <StepLabel
                  StepIconProps={{
                    classes: {
                      root: classes.root,
                      completed: classes.completed,
                      active: classes.active,
                      text: classes.iconText
                    }
                  }}
                  classes={{
                    label: classes.label,
                    alternativeLabel: classes.alternativeLabel
                  }}
                  completed={completedSteps[index] && activeStep !== index}
                  onClick={() => handleStep(index)}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Container>
      ) : null}
    </>
  );
}
